import { useMemo } from 'react';

import TabControl from '../../../components/tabs/TabControl';
import { PathsLayouts } from '../../../config/routes';
import { PermissionName } from '../../../types/Auth';
import TcPaymentSettings from '../../TuitionContinuityTariffAndTuition/tcPaymentSettings';
import TcTariff from '../../TuitionContinuityTariffAndTuition/tcTariff';
import Discount from './Discount';
import Partnership from './Partnership';
import Subsidy from './Subsidy';
import Tariff from './Tariff';
import { useTariffTabsConfig } from './useTariffTabsConfig';
// import Tuition from './Tuition';

export default function TariffAndTuition() {
  const tabsPrefix = 'tariffAndTuition.tabs';
  const { config } = useTariffTabsConfig();
  const tabs = useMemo(
    () => [
      // { name: 'tuitions', content: <Tuition /> }, POSIBLEMENTE BORRAR CON TODO SU CONTENIDO CUANDO SE REVISE EL FLUJO NUEVO
      { name: 'tariff', content: <Tariff /> },
      {
        name: 'tariff-continuity',
        content: <TcTariff />,
        permissions: [PermissionName.TUITION_CONTINUITY_TARIFF_AND_TUITION],
      },
      {
        name: 'tariff-continuity-payment-settings',
        content: <TcPaymentSettings />,
        permissions: [PermissionName.TUITION_CONTINUITY_TARIFF_AND_TUITION],
      },
      { name: 'discounts', content: <Discount /> },
      ...(config.subsidiesEnabled
        ? [{ name: 'subsidies', content: <Subsidy /> }]
        : []),
      ...(config.partnershipsEnabled
        ? [{ name: 'partnerships', content: <Partnership /> }]
        : []),
    ],
    [config.subsidiesEnabled, config.partnershipsEnabled],
  );

  return (
    <>
      <TabControl
        tabsPrefix={tabsPrefix}
        tabs={tabs}
        path={PathsLayouts.tariffAndTuiton}
      />
    </>
  );
}
